import { SOCIETE_CLAIM_TIERS } from './constants';
import { isKnownValue } from '../parseHelpers';
import { isValidCampaignSlug } from './slug';
import type { PayloadValidationResult } from '../types';
import type { StatusCampaignPayloadBuilderState } from './types';
import { validateRequiredString } from '../validationHelpers';

export function validateStatusClaimPayload(state: StatusCampaignPayloadBuilderState): PayloadValidationResult {
  const errors: Array<string> = [];

  validateRequiredString(state.campaignId, 'Campaign ID', errors);
  validateRequiredString(state.slug, 'Campaign URL Slug', errors);
  if (state.slug.trim() && !isValidCampaignSlug(state.slug)) {
    errors.push('Campaign URL Slug must be lowercase letters, numbers, and hyphens');
  }
  validateRequiredString(state.termsSlug, 'Campaign Terms Slug', errors);
  validateRequiredString(state.heroTitle, 'Hero Title', errors);
  validateRequiredString(state.heroSubtitle, 'Hero Subtitle', errors);
  validateRequiredString(state.heroImageId, 'Hero Image ID', errors);
  validateRequiredString(state.partnerName, 'Partner Name', errors);
  validateRequiredString(state.partnerLogoImageId, 'Partner Logo Image ID', errors);

  if (state.tiersGranted.length === 0) {
    errors.push('Tiers Granted requires at least one tier');
  }
  const invalidTiers = state.tiersGranted.filter((tier) => !isKnownValue(tier, SOCIETE_CLAIM_TIERS));
  if (invalidTiers.length > 0) {
    errors.push(`Tiers Granted contains invalid tiers: ${invalidTiers.join(', ')}`);
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}

export function isStatusClaimPayloadComplete(state: StatusCampaignPayloadBuilderState): boolean {
  return validateStatusClaimPayload(state).isValid;
}
